import { z } from 'zod';

const objectId = z.string().regex(/^[0-9a-fA-F]{24}$/);

const AttributeMapSchema = z.object({
    firstName: z.string().min(1).optional(),
    lastName: z.string().min(1).optional(),
    email: z.string().min(1).optional(),
    title: z.string().min(1).optional()
});

export const UpsertTenantDirectoryConfigSchema = z.object({
    enabled: z.boolean().optional(),
    url: z.string().min(1).optional(),
    bindDn: z.string().optional(),
    /** Omit or empty string keeps existing secret */
    bindPassword: z.string().optional(),
    baseDn: z.string().optional(),
    userSearchFilter: z.string().optional(),
    jitProvisioning: z.boolean().optional(),
    syncProfileFields: z.boolean().optional(),
    userListFilter: z.string().optional(),
    attributeMap: AttributeMapSchema.optional()
});

export const ListDirectoryUsersQuerySchema = z.object({
    search: z.string().optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
    /** JSON object of column key → selected values, from the table filter. */
    filters: z.string().optional(),
});

const guid = z.string().regex(
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
);

export const ImportDirectoryUsersSchema = z.object({
    objectGuids: z.array(guid).min(1).max(200),
    roleIds: z.array(objectId).optional(),
    applyRoleMappings: z.boolean().optional(),
    unitId: objectId.optional()
});

export const CreateLdapRoleMappingSchema = z.object({
    sourceAttribute: z.enum(['memberOf', 'title']),
    matchType: z.enum(['exact', 'contains']).optional(),
    pattern: z.string().min(1),
    roleIds: z.array(objectId).min(1),
    customFields: z.record(z.unknown()).optional(),
});

export const UpdateLdapRoleMappingSchema = z.object({
    sourceAttribute: z.enum(['memberOf', 'title']).optional(),
    matchType: z.enum(['exact', 'contains']).optional(),
    pattern: z.string().min(1).optional(),
    roleIds: z.array(objectId).min(1).optional(),
    customFields: z.record(z.unknown()).optional(),
});
